import React from "react";
import { useIntl } from "react-intl";
import Fuse from "fuse.js";
import { useSearchParams } from "react-router-dom-v5-compat";
import { trackingShape, withTracking } from "../../context";
import {
  isNotEmpty,
  isTouchDevice,
  isNullOrEmpty,
  formatDateTime,
} from "../../utils";
import { documentsShape } from "../../shapes";
import SearchBar from "./SearchBar";
import { annotateResult, extractItems } from "../../utils/searchDocumentsUtils";
import { useUrlState } from "../../hooks/useUrlState";

type OwnProps = {
  documentList?: documentsShape;
  onSearch?: $TSFixMeFunction;
  tracking: trackingShape;
};

const defaultProps: Partial<OwnProps> = {
  documentList: [],
  onSearch: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function SearchDocuments({ documentList, onSearch, tracking }: Props) {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filesQuery, setFilesQuery] = useUrlState(
    "filesQuery",
    searchParams,
    setSearchParams,
  );
  const timeoutRef = React.useRef(null);

  const searchOptions = {
    includeMatches: true,
    findAllMatches: true,
    ignoreLocation: true,
    threshold: 0.0,
    keys: [
      "name",
      "categories.name",
      "categories_label",
      "attachments.file_name",
      "attachments.content_date",
      "defaultAttachment.content_date",
    ],

    getFn: (obj: $TSFixMe, path: $TSFixMe) => {
      const key = path.join(".");

      let value = Fuse.config.getFn(obj, path);

      if (
        key === "attachments.content_date" &&
        obj?.attachments[0]?.content_date
      ) {
        const contentDate = obj?.attachments[0].content_date;
        value = formatDateTime(contentDate, intl);
      }

      if (
        key === "defaultAttachment.content_date" &&
        obj?.defaultAttachment?.content_date
      ) {
        const contentDate = obj.defaultAttachment.content_date;
        value = formatDateTime(contentDate, intl);
      }

      return value;
    },
  };

  const handleOnSearch = (term: $TSFixMe) => {
    if (isNotEmpty(term) && !isNullOrEmpty(term)) {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'documentsShape | undefined' is n... Remove this comment to see the full error message
      const fuse = new Fuse(documentList, searchOptions);
      const a = fuse.search(term);
      const result = annotateResult(a);
      const documents = extractItems(result);
      setFilesQuery(term);

      // TODO - outsource debounce behaviour to a custom hook and use it in Netilion e.G. SearchBar as well.
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      clearTimeout(timeoutRef.current);
      // @ts-expect-error TS(2322) FIXME: Type 'Timeout' is not assignable to type 'null'.
      timeoutRef.current = setTimeout(() => {
        tracking.trackEvent("DocumentsSearch-typed", { term });
      }, 1250);

      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onSearch(documents);
    } else {
      setFilesQuery(null);
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onSearch(documentList);
    }
  };

  React.useEffect(() => {
    if (filesQuery.length) handleOnSearch(filesQuery);
  }, []);

  return (
    <div>
      <SearchBar
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; autoFocus: boolean; onSearch: ... Remove this comment to see the full error message
        id="searchBar"
        autoFocus={!isTouchDevice()}
        onSearch={handleOnSearch}
        placeholder={intl.formatMessage({ id: "search.searchbox_placeholder" })}
        minChars={1}
        timeout={150}
        resettable
        filterWildcard={false}
        defaultValue={filesQuery}
      />
    </div>
  );
}

SearchDocuments.defaultProps = defaultProps;

export default withTracking(SearchDocuments);
